import { PosterResult } from './../services/certificados'
import certificadosService from '../services/certificados'
import { Poster } from './../models/poster'
import { Module } from 'vuex'
import Swal from 'sweetalert2'
import { downloadBlob } from '../util'

export type CertificateData = Poster | null
export interface CertificadosData {
  data: CertificateData
}
// eslint-disable-next-line
export interface CertificadosModuleState extends CertificadosData {}

const certificadosModule: Module<CertificadosModuleState, any> = {
  namespaced: true,
  state: {
    data: null,
  },

  mutations: {},

  actions: {
    async carta(_, { data }: { data: any }): Promise<PosterResult | null> {
      let result: PosterResult
      try {
        result = await certificadosService.carta(data)
      } catch (err) {
        Swal.fire(
          'Error',
          'No fue posible generar su carta de aceptación',
          'error'
        )
        return null
      }

      if (result.error) {
        Swal.fire(
          'Error',
          'No fue posible generar su carta de aceptación',
          'error'
        )
      } else {
        const file = new Blob([result.data], { type: 'application/pdf' })
        downloadBlob(file, `${data.nombres} ${data.apellidos}.pdf`)
      }
      return result
    },
  },
}

export default certificadosModule
